import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React      from 'react';
import ReactDOM   from 'react-dom/client';
import {
    BrowserRouter
}                 from 'react-router-dom';

import intelitransit from './utils/InteliTransit';
import App           from './App';

(async () => {
    try {
        if( await intelitransit.init() ) {
            //@ts-expect-error TS2339
            window.intelitransit = intelitransit;
            const root = (document.getElementById('root')!);
            ReactDOM.createRoot(root).render(
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            );
        }
        else {
            // the browser is already redirected
        }
    }
    catch( err ) {
        const root = (document.getElementById('root')!);
        ReactDOM.createRoot(root).render(
            <p>Cannot init InteliTransIT: {(err as Error).message}</p>,
        );
    }
})();

